import React, { useState,useEffect } from 'react'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
function PolicyCom() {
	const [policyurl, setPolicyurl] = useState('QBS_EMS-Policy-Statement-signed.pdf');
	const [policytitle, setPolicytitle] = useState('Environmental Management Policy');
	

	var systemrole = localStorage.getItem('systemRole')
	const location = useLocation();
	var string = location.search
	useEffect(() => {
		let tmp = string.substring(1)
		if(tmp=='ems-policy'){
			setPolicyurl('QBS_EMS-Policy-Statement-signed.pdf')
			setPolicytitle('Environmental Management Policy')
		}
		if(tmp=='hsp'){
			setPolicyurl('QBS_Health-and-Safety-Policy-Staement-signed.pdf') 
			setPolicytitle('Health & Safety Policy')
		}
		if(tmp=='isms'){
			setPolicyurl('QBS_ISMS-Policy-Statement-Signed.pdf') 
			setPolicytitle('ISMS Policy')
		}
		if(tmp=='qualitypolicy'){
			setPolicyurl('Quality-Policy.pdf') 
			setPolicytitle('Quality Policy')
		}
		if(tmp=='codeofconduct'){
			setPolicyurl('Learning_Code_of_Conduct.pdf') 
			setPolicytitle('Code Of Conduct')
		}
		if(tmp=='empmanual'){
			setPolicyurl('EMPLOYEE_MANUAL.pdf') 
			setPolicytitle('Employee Manual')
		}
		


	}, [location])
	return (
		<>
			{/* <div id="sidebar">
				<nav id="sidebarMenu" className="d-md-block sidebar">
					<div className="position-sticky">
						<ul className="nav flex-column">
							<li class="nav-item active">
								<button class="btn btn-toggle nav-link active align-items-center" data-bs-toggle="collapse" data-bs-target="#home-collapse" aria-expanded="true">
									Policy
									<i class="icon icon-chevron-right"></i>
								</button>
								<div class="collapse submenu show" id="home-collapse">
									<ul>
										<li>
											<button className={` ${activemenu == 1 ? 'active' : ''}`} onClick={() => handlePolicy('QBS_EMS-Policy-Statement-signed.pdf', 'Environmental Management Policy', 1)}>
												-  EMS Policy
											</button>
										</li>
										<li>
											<button className={`${activemenu == 2 ? 'active' : ''}`} onClick={() => handlePolicy('QBS_Health-and-Safety-Policy-Staement-signed.pdf', 'Health & Safety Policy', 2)}>
												-  Health & Safety Policy
											</button>
										</li>
										<li>
											<button className={` ${activemenu == 3 ? 'active' : ''}`} onClick={() => handlePolicy('QBS_ISMS-Policy-Statement-Signed.pdf', 'ISMS Policy', 3)}>
												-  ISMS Policy Statement
											</button>
										</li>
										<li>
											<button className={` ${activemenu == 4 ? 'active' : ''}`} onClick={() => handlePolicy('Quality-Policy.pdf', 'Quality Policy', 4)}>
												-  Quality Policy
											</button>
										</li>
										<li>
											<button className={`${activemenu == 5 ? 'active' : ''}`} onClick={() => handlePolicy('Learning_Code_of_Conduct.pdf', 'Code Of Conduct', 5)}>
												-  Code Of Conduct
											</button>
										</li>
										<li>
											<button className={`${activemenu == 6 ? 'active' : ''}`} onClick={() => handlePolicy('EMPLOYEE_MANUAL.pdf', 'Employee Manual', 6)}>
												-  Employee Manual
											</button>
										</li>
									</ul>
								</div>
							</li>
							{(() => {
								if (systemrole == 2) {
									return (
										<>
											<li className="nav-item">
												<Link to='/employeelist' className='nav-link'>
													Employee List
												</Link>
											</li>
											<li className="nav-item">
												<Link to='/resetpassword' className='nav-link'>
													Reset Password
												</Link>
											</li>
										</>
									)
								}
							})()}


						</ul>
					</div>
				</nav>

			</div> */}
			
				<div className="page-header">
					<h1>HR Policy</h1>
				</div>
				<div class="row_bg">
					<div class="box_white mb20">
						<div class="box_heading">
							{policytitle ? policytitle : ''}
						</div>
						<div class="box_content">
							<embed src={"assets/policy_pdf/" + policyurl + "#toolbar=0"} width="100%" height="450px" />
							<div class="note_wrp mt10">Note: These documents are for QBS internal purpose only and not to be shared outside of QBS.</div>
						</div>

					</div>
				</div>


			
		</>
	)
}

export default PolicyCom
